// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Service imports
import { CommunityService } from '../../_services/data-services/community.service';
import { HelperService } from '../../_services/shared-services/helper.service';

@Component({
    selector: 'app-property-community-link',
    templateUrl: './property-community-link.component.html',
    styleUrls: ['./property-community-link.component.scss']
})
export class PropertyCommunityLinkComponent implements OnInit {
    @Input() communityId: number;
    @Input() customerId: string;
    @Input() displayText: string;
    @Input() linkEnabled = true;
    @Output() onClick = new EventEmitter<void>();

    iconTransition = IconConstants.IN_TRANSITION;
    iconTerminate = IconConstants.TERMINATE;
    iconExclamatory = IconConstants.EXCLAMATION_CIRCLE;

    communityStatus = '';
    communityIsTerminating: boolean;
    communityTerminatingDate: Date;

    hyperlinkTitle: string;

    constructor(private readonly communityService: CommunityService, private readonly helperService: HelperService) {}

    ngOnInit(): void {
        const result = this.communityService.getCommunityStatusInfo(this.communityId);
        if (Utils.notNullAndDefined(result) && Utils.notNullAndDefined(result.status)) {
            this.communityStatus = result.status;
            this.communityTerminatingDate = result.terminatingDate;
            this.communityIsTerminating = result.isTerminating;
            this.hyperlinkTitle = Utils.notNullAndDefined(this.customerId) ? this.displayText : this.getStatus();
        } else {
            this.linkEnabled = false;
        }
    }

    onLinkClick(): void {
        if (Utils.notNullAndDefined(this.customerId)) {
            this.navigateToPropertyHome();
        } else if (Utils.notNullAndDefined(this.communityId)) {
            this.navigateToCommunityHome();
        }

        this.onClick.emit();
    }

    getStatus(): string {
        if (Utils.notNullAndDefined(this.communityStatus)) {
            const date = this.helperService.getDateString(this.communityTerminatingDate);
            return Utils.isTrue(this.communityIsTerminating) &&
                Utils.notEqualsIgnoreCase(this.communityStatus, 'Terminated')
                ? `Community will terminate on ${date}`
                : this.communityStatus;
        }
    }

    private navigateToPropertyHome(): void {
        this.helperService.openDefaultPropertyPageInNewWindow(this.communityId, this.customerId);
    }

    private navigateToCommunityHome(): void {
        this.helperService.openDefaultCommunityPageInNewWindow(this.communityId);
    }
}
